module.exports = __webpack_public_path__ + "static/media/logo counter.5d80faf2.png";